import { FragranceOption } from './types';

export const fragranceDirectionOptions: FragranceOption[] = [
  {
    name: 'topics:fragrance:options:availableDirection:citrus',
    value: 'citrus',
  },
  {
    name: 'topics:fragrance:options:availableDirection:chypre',
    value: 'chypre',
  },
  {
    name: 'topics:fragrance:options:availableDirection:floral',
    value: 'floral',
  },
  {
    name: 'topics:fragrance:options:availableDirection:floriental',
    value: 'floriental',
  },
  {
    name: 'topics:fragrance:options:availableDirection:fruity',
    value: 'fruity',
  },
  {
    name: 'topics:fragrance:options:availableDirection:gourmand',
    value: 'gourmand',
  },
  {
    name: 'topics:fragrance:options:availableDirection:green',
    value: 'green',
  },
  {
    name: 'topics:fragrance:options:availableDirection:herbal',
    value: 'herbal',
  },
  {
    name: 'topics:fragrance:options:availableDirection:lavender',
    value: 'lavender',
  },
  {
    name: 'topics:fragrance:options:availableDirection:musk',
    value: 'musk',
  },
  {
    name: 'topics:fragrance:options:availableDirection:oriental',
    value: 'oriental',
  },
  {
    name: 'topics:fragrance:options:availableDirection:pine',
    value: 'pine',
  },
  {
    name: 'topics:fragrance:options:availableDirection:spicy',
    value: 'spicy',
  },
  {
    name: 'topics:fragrance:options:availableDirection:woody',
    value: 'woody',
  },
];
